/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { JOB_ROOM } from "../RoomNameConstants";

const state = {
    ID: JOB_ROOM,
    isManipulable: {
        stateName: "centerGraph",
        settings: {
            selected: null,
            enabled: { VR: ["rotation", "zoom", "explore"], desktop: ["rotation"] },
        },
    },
    chartTimeSelection: "This month",
    lastTenRunsTable: [],
    lastTenRunsChart: {},
    dataChartStartTime: {},
    dataChartDuration: {},
    rightPanelSelector: "Starting time",
    leftPanelSelector: "Duration Chart",
    lastDefinitonChangesData: [],
    openedModal: null
};

export default state;
